module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-700.dfa6c4c1.ttf";